import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { LinkedChecksInfo } from "../../../common/LinkedChecksInfo.js";
import ReusableAccordion from "../../../../../../../components/ReusableAccordion/ReusableAccordion.js";
import { EmptyFields } from "../../../../../../../utils/enums.js";

const MappedControlContent = ({ data, loading }) => {
  const [expanded, setExpanded] = useState(null);

  const sortedControls = [...(data || [])].sort(
    (a, b) => a.controls_id - b.controls_id
  );

  if (!sortedControls.length) {
    return (
      <Box sx={{ p: 3, color: "text.secondary" }}>No controls mapped.</Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={0}>
      {sortedControls?.map((control, idx) => (
        <ReusableAccordion
          key={control?.controls_id || idx}
          expanded={expanded === idx}
          onChange={() => setExpanded(expanded === idx ? null : idx)}
          summary={
            <>
              {idx + 1}. {control?.controls_name} :{" "}
              {control?.control_title ?? EmptyFields.TITLE}
            </>
          }
          details={
            control?.associated_checks?.length > 0 ? (
              <LinkedChecksInfo control={control} toShowStatus={true} />
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                No checks mapped to this control.
              </Typography>
            )
          }
        />
      ))}
    </Box>
  );
};

export default MappedControlContent;
